import React, { memo, useEffect, useRef, useState } from 'react'
import Nosidebar from '@/components/NoSidebar'
import styles from './index.module.scss'
import { useTranslation } from 'react-i18next'
import { Button, QRCode } from 'antd'
import Lottie from '@/components/Lottie'

import successLottie from '@/assets/lottie/activation-step-4-1.json'
import cancelLottie from '@/assets/lottie/result-fail.json'
import { getBrowser, getOS } from '@/utils/utils'
import { LoginCodeModel, LoginStateInfo, QcodeLoginStateEnum } from '@/services/apis/user/model'
import UserApi from '@/services/apis/user/index'
import uuidUtil from '@/utils/uuid'

import { useNavigate } from 'react-router-dom'

const Login = memo(() => {
  const { t } = useTranslation()
  const codeLoop = useRef<any>()
  const stateLoop = useRef<any>()
  const navigate = useNavigate()
  // 获取浏览器信息
  function browserInfo() {
    return {
      browser: getBrowser() || t('other.other'),
      os: getOS() || t('other.other'),
    }
  }
  const [loginCode, setLoginCode] = useState<LoginCodeModel>({} as LoginCodeModel)
  const [stateInfo, setStateInfo] = useState<LoginStateInfo>({ state: 1 } as LoginStateInfo)
  const realCode = () => {
    if (!loginCode.code) return ''

    const loginInfo = Object.keys(loginCode).reduce((res, cur) => {
      // @ts-ignore
      res += `${cur}=${encodeURIComponent(loginCode[cur])}&`
      return res
    }, '')

    return `${loginInfo}browser=${browserInfo().browser}&OS=${browserInfo().os}`
  }

  const getCode = async () => {
    setLoginCode({} as LoginCodeModel)
    setStateInfo({
      state: 1,
    } as any)
    const res = await UserApi.getLoginCode()
    if (res.success) {
      setLoginCode(res.data)
      codeLoop.current = setTimeout(() => {
        getCode()
      }, res.data.overdueTime - Date.now())
    }
  }
  const getState = async () => {
    const res = await UserApi.loginVerify(loginCode.code)
    if (res.success) {
      setStateInfo(res.data)
      if (res.data.state === QcodeLoginStateEnum.SUCCESS) {
        uuidUtil.setUUID(res.data.token)
        // 需要重定向
        navigate('/home')
      }
    } else {
      clearInterval(stateLoop.current)
      getCode()
    }
  }

  const startStateLoop = () => {
    stateLoop.current = setInterval(async () => {
      await getState()
    }, 5000)
  }

  useEffect(() => {
    getCode()
    return () => {
      clearTimeout(codeLoop.current)
    }
  }, [])
  useEffect(() => {
    startStateLoop()
    return () => {
      clearInterval(stateLoop.current)
    }
  }, [loginCode.code])

  return (
    <Nosidebar>
      <div className={styles.login}>
        <h1 className={styles.title}>{t('login.loginTitle')}</h1>
        {stateInfo?.state === QcodeLoginStateEnum.INIT && (
          <>
            <div className={styles.content}>
              <QRCode value={realCode() || ''} size={240} errorLevel="Q" />
            </div>
            <p className={styles.desc}>{t('login.loginDesc')}</p>
          </>
        )}
        {stateInfo?.state === QcodeLoginStateEnum.WAITING && (
          <>
            <Lottie loop={true} data={successLottie} style={{ marginTop: '-30px' }}></Lottie>
            <p>{t('login.scanSuccess')}</p>
          </>
        )}
        {stateInfo?.state === QcodeLoginStateEnum.SUCCESS && (
          <>
            <Lottie loop={true} data={successLottie} style={{ marginTop: '-30px' }}></Lottie>
            <p>{t('login.scanSuccess')}</p>
          </>
        )}
        {stateInfo?.state === QcodeLoginStateEnum.CANCELED && (
          <>
            <>
              <Lottie
                data={cancelLottie}
                loop={false}
                style={{ width: '200px', height: '200px', marginTop: '-30px' }}
              />
              <p>{t('login.cancel')}</p>
              <Button type="primary" style={{ width: '140px' }} onClick={getCode}>
                {t('login.again')}
              </Button>
            </>
          </>
        )}
        {stateInfo?.state === QcodeLoginStateEnum.INVALID && (
          <>
            <Lottie loop={true} data={successLottie} style={{ width: '440px' }} />
            <p>{t('login.invalid')}</p>
            <Button type="primary" style={{ width: '140px' }} onClick={getCode}>
              {t('common.refresh')}
            </Button>
          </>
        )}
      </div>
    </Nosidebar>
  )
})

export default Login
